export default __webpack_public_path__ + "static/media/home-hero.49a3db07.png";